import { useState } from 'react'
import { createPortal } from 'react-dom'
import { Link } from 'react-router-dom'

import Text from 'components/common/BaseText/BaseText'
import BurgerBtn from 'components/BurgerBtn/BurgerBtn'
import BaseLink from 'components/common/BaseLink/BaseLink'
import useWindowSize from 'hooks/useWindowSize'

import './Navigation.scss'

const Navigation: React.FC = (): JSX.Element => {
	const [isMobileNavOpened, setIsMobileNavOpened] = useState(false)

	const { width } = useWindowSize()
	const isMobile = width <= 768

	const handleMobileNavToggle = () => {
		setIsMobileNavOpened(prevState => !prevState)
	}

	const handleCloseNavigation = () => {
		setIsMobileNavOpened(false)
	}

	if (isMobile) {
		return (
			<header className='nav-mobile' id='nav'>
				<div className='nav-mobile__wrapper'>
					<Link className='nav-mobile__logo' to='/' onClick={handleCloseNavigation}>
						<Text type='h1'>Mateusz.dev</Text>
					</Link>

					<BurgerBtn onClick={handleMobileNavToggle} isOpened={isMobileNavOpened} />
				</div>

				{createPortal(
					<aside className={`nav-mobile__backdrop nav-mobile__backdrop--${isMobileNavOpened ? 'shown' : 'hidden'}`}>
						<nav className='nav-mobile__items' onClick={handleCloseNavigation}>
							<BaseLink target='nav'>Home</BaseLink>
							<BaseLink target='about'>About</BaseLink>
							<BaseLink target='products'>How I work</BaseLink>
							<BaseLink target='projects'>My projects</BaseLink>
							<BaseLink target='contact'>Contact</BaseLink>
						</nav>
					</aside>,
					document.body
				)}
			</header>
		)
	}

	return (
		<header className='nav'>
			<div className='nav__wrapper'>
				<Link className='nav__logo' to='/'>
					<Text type='h1'>Mateusz.dev</Text>
				</Link>

				<nav className='nav__items' id='nav'>
					<BaseLink target='nav'>Home</BaseLink>
					<BaseLink target='about'>About</BaseLink>
					<BaseLink target='products'>How I work</BaseLink>
					<BaseLink target='projects'>My projects</BaseLink>
					<BaseLink target='contact'>Contact</BaseLink>
				</nav>
			</div>
		</header>
	)
}

export default Navigation
